module.exports = __webpack_public_path__ + "img/berry-crunch-treat.1ad52d11.jpg";